import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

const isProd = window.location.origin === "https://teacher-read.web.app";

const devConfig = {
  apiKey: "AIzaSyDtY3oUpmukHvcuFoY-5iojNVI4TxZnIys",
  authDomain: "teacher-read-dev.firebaseapp.com",
  projectId: "teacher-read-dev",
  storageBucket: "teacher-read-dev.appspot.com",
  messagingSenderId: "100360599754",
  appId: "1:100360599754:web:6cfa4100d062b5dba41c33",
  measurementId: "G-NFX75JY9Q5",
};
const prodConfig = {
  apiKey: "AIzaSyABxKFaHy9q1PNE6gHnZ-0eUShmLirtXnQ",
  authDomain: "teacher-read.firebaseapp.com",
  projectId: "teacher-read",
  storageBucket: "teacher-read.appspot.com",
  messagingSenderId: "1049015787948",
  appId: "1:1049015787948:web:db5d7cd67dd5ee61ad9a09",
  measurementId: "G-M50EZRH3L1",
};
const firebaseConfig = isProd ? prodConfig : devConfig;

const firebaseApp = firebase.initializeApp(firebaseConfig);

const vueApp = createApp(App);

vueApp.use(router);
vueApp.config.globalProperties.$firebase = firebaseApp;

vueApp.mount("#app");
